// components/WoPDF.jsx
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { formatDateOnly, renderImage } from "../../../utils/helper.jsx";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  section: {
    marginBottom: 10,
  },
  row: {
    flexDirection: "row",
  },
  widthLabel: {
    width: 100,
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
  },
  assetContainer: {
    marginBottom: 15,
    borderBottomWidth: 1,
    paddingBottom: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  assetText: {
    flexGrow: 1,
  },
  image: {
    marginRight: 10,
    width: 80,
    height: 80,
    objectFit: "cover",
  },
});

const DocumentPreview = ({ data, attachments }) => (
  <Document>
    <Page style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.title}>Title : {data.title}</Text>
        <View style={styles.row}>
          <Text style={styles.widthLabel}>Created: </Text>
          <Text>{formatDateOnly(data.created_at)}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.widthLabel}>Description:</Text>
          <Text>{data.description}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.widthLabel}>Status:</Text>
          <Text>{data.status}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.widthLabel}>Asset:</Text>
          <Text>{data.asset}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.widthLabel}>Priority:</Text>
          <Text>{data.priority}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.widthLabel}>Assigned to:</Text>
          <Text>{data.assigned}</Text>
        </View>
      </View>

      {attachments && (
        <View style={styles.section}>
          {attachments.length && <Text style={styles.title}>Attachment</Text>}
          {attachments.map((attachment, index) =>
            attachment.type === "image" ? (
              <View key={index} style={styles.assetContainer}>
                <Image style={styles.image} src={attachment.url} />
              </View>
            ) : null
          )}
        </View>
      )}

      <View style={styles.section}>
        <Text style={styles.title}>Tasks</Text>
        {data.tasks.map((task, index) => (
          <View>
            <View key={index} style={styles.assetContainer}>
              <Text style={styles.assetText}>{task.task_name}</Text>
              <Text>{task.task_status}</Text>
            </View>
            {task.task_photo && (
              <View style={styles.row}>
                <Image style={styles.image} src={task.url_full} />
                <Text>Note : {data.task_note}</Text>
              </View>
            )}
          </View>
        ))}
      </View>
      <View style={styles.section}>
        <Text style={styles.title}>Parts</Text>
        {data.inventories.map((task, index) => (
          <View>
            <View key={index} style={styles.assetContainer}>
              <Text style={styles.assetText}>
                {task.inventory?.part?.part_name}
              </Text>
              <Text>{task.quantity} pcs</Text>
            </View>
            {task.task_photo && (
              <View style={styles.row}>
                <Image style={styles.image} src={task.url_full} />
                <Text>Note : {data.task_note}</Text>
              </View>
            )}
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

const WoPDF = ({ data, open, setOpen, attachments }) => {
  const handleDownload = () => {
    setOpen(false);
  };
  return (
    <ConfirmationDlg
      open={open}
      hideCancelBtn={true}
      btnSubmitText={"Close"}
      onClose={() => setOpen(false)}
      onSubmit={handleDownload}
    >
      <div style={{ width: "100%", height: "500px", marginBottom: "20px" }}>
        <PDFViewer width="100%" height="100%">
          <DocumentPreview data={data} attachments={attachments} />
        </PDFViewer>
      </div>

      <PDFDownloadLink
        document={<DocumentPreview data={data} />}
        fileName="asset-report.pdf"
      >
        {({ loading }) =>
          loading ? "Generating PDF..." : <button>Download PDF</button>
        }
      </PDFDownloadLink>
    </ConfirmationDlg>
  );
};

export default WoPDF;
